import { EventCategory } from "@/domain/event";
import { EventHandler } from "./types";

const registry = new Map<EventCategory, EventHandler>();

export function registerEvent( category: EventCategory, handler: EventHandler ) {
    // 注册
    if ( registry.has( category ) ) {
        console.warn( `[event] duplicate register: ${category}` );
        return;
    }
    registry.set( category, handler );
}
export function getEventHandler( category: EventCategory ) {
    return registry.get( category );
}
